<div class="avatar-container" (click)="onChangeImage()">
  <glxy-avatar [src]="newUploadedImageUrl() || imageUrl()" [svgIcon]="defaultSvg()" [width]="220"></glxy-avatar>

  <div class="edit-overlay">
    <mat-icon>photo_camera</mat-icon>
  </div>

  @if (newUploadedImageUrl() || imageUrl()) {
    <div class="badge-container">
      <glxy-avatar [svgIcon]="defaultSvg()" class="badge-icon" [width]="60"></glxy-avatar>
    </div>
  }
</div>
